import { render, staticRenderFns } from "./IconMenuRewards.vue?vue&type=template&id=ea3d5522&"
import script from "./IconMenuRewards.vue?vue&type=script&lang=js&"
export * from "./IconMenuRewards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea3d5522')) {
      api.createRecord('ea3d5522', component.options)
    } else {
      api.reload('ea3d5522', component.options)
    }
    module.hot.accept("./IconMenuRewards.vue?vue&type=template&id=ea3d5522&", function () {
      api.rerender('ea3d5522', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconMenuRewards.vue"
export default component.exports